import styled from 'styled-components';
import { rgba } from 'polished';

import { NAVBAR_HEIGHT, NAVBAR_ZINDEX } from '../../constants/ui';

import * as Colors from '../../attrs/colors';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: ${NAVBAR_HEIGHT}px;
  z-index: ${NAVBAR_ZINDEX};
  background: ${rgba(Colors.WHITE, 0.9)};
  backdrop-filter: saturate(150%) blur(5px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 1rem;
  box-shadow: inset 0 -1px 0 ${rgba(Colors.BLACK, 0.1)};
`;
